import React from "react";
import { useState } from "react";
import styled from "styled-components";
import { Collapse } from "reactstrap";
import { InputField1 } from "../../../InputField1/InputField1";
import Typography from "../../../Typography/Typography";
import { HiOutlineArrowNarrowLeft, HiArrowCircleDown } from "react-icons/hi";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";
import { DataPicker } from "../../../DataPicker/DataPicker";
import { MiladiToShamsi } from "../../../../utils/Miladi_To_Shamsi";
import { formatDate } from "../../../../utils/formatDate";
import { MdCancelPresentation } from "react-icons/md";
import GetCategoryLevelOne from "../../../Dialog/contentUnit/newProduct/GetCategoryLevelOne";
import GetCategoryLevelTwo from "../../../Dialog/contentUnit/newProduct/GetCategoryLevelTwo";
import GetCategoryLevelThree from "../../../Dialog/contentUnit/newProduct/GetCategoryLevelThree";
import { errorMessage } from "../../../../utils/message";
import { SelectMulti } from "../../../MultiSelect/MultiSelect";
import moment from "jalali-moment";
import {
  useGetOccationList,
  useGetSupplierList,
  useGetPropertyList,
  useGetPropertyListLevelTow,
  useGetAllPropertyLevelTowOption,
  useFetchAllPropertyList,
} from "../../../../hooks/useContent";
import Spinner from "react-bootstrap/Spinner";
import { useRef } from "react";

const PropertyChooser = ({
  number,
  property,
  handleDelete,
  handleChange,
  optionLevel1,
  optionLevelTow,
  handleUpdateLevel2,
}) => {
  const [levelTwoOptions, setLevelTwoOption] = useState(
    optionLevelTow?.filter((proper) => proper?.value === property.level1)
  );

  const selectRef = useRef();

  const handleUpdateProperty = (e, name) => {
    const { value, label } = e;

    selectRef.current.clearValue();
    if (name === "level1") {
      setLevelTwoOption(
        levelTwoOptions?.filter((proper) => proper?.value === value)
      );
      handleChange(property?.id, -1, "level2");
      handleChange(property?.id, value, name);
    } else {
      property?.level1.value === -1
        ? errorMessage("لطفا ابتدا ویژگی سطح یک را انتخاب کنید")
        : handleChange(property?.id, value, name);
    }
  };

  return (
    <PropertyChooserStyle>
      <div className="title">
        <Typography>_{number}</Typography>
        <MdCancelPresentation
          size={"25px"}
          style={{ cursor: "pointer" }}
          onClick={(e) => handleDelete(property.id)}
        />
      </div>
      <div className="getProperty">
        <div className="rowEl">
          <SimpleSelect1
            onChange={(e) => handleUpdateProperty(e, "level1")}
            res={optionLevel1}
            label={"ویژگی سطح 1"}
          />
        </div>
        <div className="rowEl">
          <SelectMulti
            inputRef={selectRef}
            onChange={(e) => handleUpdateLevel2(e, property?.id)}
            res={optionLevelTow?.filter(
              (propLevel) => propLevel?.parent === property?.level1
            )}
            label={"ویژگی سطح 2"}
          />
        </div>
      </div>
    </PropertyChooserStyle>
  );
};

function AddProperty({
  levelsProperty,
  setLevelsProperty,
  NewProduct,
  setNewProduct,
  IdFeatureValue,
  setIdFeatureValue,
}) {
  const [showOccation, setOccation] = useState(false);

  const {
    data: occationList,
    isFetching: isFetchOccations,
    isError: occationError,
  } = useGetOccationList("", "");

  const {
    data: supplierList,
    isFetching: isFetchSupplier,
    isError: supplierError,
  } = useGetSupplierList();

  const {
    data: propertyLevel1List,
    isFetching: isPropertyFetch,
    isError: propertyLevel1Error,
  } = useFetchAllPropertyList();

  const {
    data: propertyLevel2List,
    isFetching: isProperty2Fetch,
    isError: propertyLevel2Error,
  } = useGetAllPropertyLevelTowOption();

  const propertyLevel1Option = propertyLevel1List?.data?.properties?.map(
    (property) => {
      return {
        value: property?.IdProperties,
        label: property?.TitleProperties,
      };
    }
  );

  const propertyLevel2Option = propertyLevel2List?.data?.feature_values?.map(
    (property) => {
      return {
        value: property?.IdFeatureValues,
        label: property?.AmountFeatureValues,
        parent: property?.IdProperties,
      };
    }
  );

  const occationListOption = occationList?.pages[0]?.data?.occasion?.map(
    (option) => {
      return { value: option?.IdOccasions, label: option?.OccasionsFarsi };
    }
  );

  const supplierOption = supplierList?.data?.Supplier?.map((supplier) => {
    return {
      value: supplier?.IdUser,
      label: supplier?.FirstName + " " + supplier?.LastName,
    };
  });

  supplierOption?.unshift({ label: "تامین کننده انتخاب کنید", value: -1 });

  occationListOption?.unshift({ label: "مناسبت انتخاب کنید", value: -1 });

  propertyLevel1Option?.unshift({
    label: "ویژگی سطح یک انتخاب کنید",
    value: -1,
  });
  propertyLevel2Option?.unshift({
    label: "ویژگی سطح دو انتخاب کنید",
    value: -1,
  });

  const [show, setShow] = useState({
    level1: false,
    level2: false,
    level3: false,
  });

  const addProperty = (e) => {
    setIdFeatureValue([
      ...IdFeatureValue,
      { level1: -1, level2: -1, id: IdFeatureValue.length + 1 },
    ]);
  };

  const handleDeleteProperty = (id) => {
    setIdFeatureValue(IdFeatureValue?.filter((data) => data.id !== id));
  };

  const handleChangeProperty = (id, newValue, name) => {
    setIdFeatureValue(
      IdFeatureValue?.map((data) => {
        if (data.id === id) return { ...data, [name]: newValue, level2: [] };
        return data;
      })
    );
  };

  const handleUpdateLevel2 = (e, id) => {
    setIdFeatureValue(
      IdFeatureValue?.map((data) => {
        if (data?.id === id) return { ...data, level2: e };
        return data;
      })
    );
  };

  return (
    <AddPropertyStyle>
      <PropertyWrapper>
        <LevelGroupChooser>
          <GroupElement onClick={(e) => setShow({ ...show, level1: true })}>
            <Label>دسته بندی سطح 1</Label>
            <SelectLevel>
              <Typography>{levelsProperty?.level1?.name}</Typography>
              <HiOutlineArrowNarrowLeft size={"25px"} />
            </SelectLevel>
          </GroupElement>
          <GroupElement
            onClick={(e) => {
              if (levelsProperty?.level1?.id !== -1)
                setShow({ ...show, level2: true });
              else errorMessage("لطفا ابتدا سطح یک را انتخاب کنید");
            }}
          >
            <Label>دسته بندی سطح 2</Label>
            <SelectLevel>
              <Typography>{levelsProperty?.level2?.name}</Typography>
              <HiOutlineArrowNarrowLeft size={"25px"} />
            </SelectLevel>
          </GroupElement>
          <GroupElement
            onClick={(e) => {
              if (levelsProperty?.level2?.id !== -1)
                setShow({ ...show, level3: true });
              else errorMessage("لطفا ابتدا سطح دو را انتخاب کنید");
            }}
          >
            <Label>دسته بندی سطح 3</Label>
            <SelectLevel>
              <Typography>{levelsProperty?.level3?.name}</Typography>
              <HiOutlineArrowNarrowLeft size={"25px"} />
            </SelectLevel>
          </GroupElement>
        </LevelGroupChooser>
        <Typography className="mt-2">دسته بندی مناسبتی</Typography>
        <Collapse isOpen={!showOccation}>
          <div className="contain">
            {isFetchOccations ? (
              <Spinner animation="border" size="sm" />
            ) : !occationError ? (
              <SimpleSelect1
                className="mt-2"
                placeholder={"مناسبت انتخاب کنید"}
                onChange={(e) =>
                  setNewProduct({ ...NewProduct, IdOccasions: e.value })
                }
                res={occationListOption}
              />
            ) : (
              <Typography primary={"red"}>
                مشکلی در گرفتن اطلاعات پیش امده
              </Typography>
            )}
          </div>
        </Collapse>
        <SupplierStyle>
          {isFetchSupplier ? (
            <Spinner animation="border" size="sm" />
          ) : supplierError ? (
            <Typography primary={"red"}>
              مشکلی در گرفتن اطلاعات پیش امده
            </Typography>
          ) : (
            <SimpleSelect1
              res={supplierOption}
              onChange={(e) =>
                setNewProduct({ ...NewProduct, supplier: e.value })
              }
              placeholder={"تامین کننده را انتخاب کنید"}
              label={"تامین کننده"}
            />
          )}
        </SupplierStyle>
        <OFFStyle>
          <InputField1
            type={"number"}
            value={NewProduct.off}
            onChange={(e) =>
              setNewProduct({ ...NewProduct, off: e.target.value })
            }
            label={"درصد تخفیف"}
          />
          <DataPicker
            onChange={(e) => {
              const parseDate = moment
                .from(`${e?.year}/${e?.month}/${e?.day}`, "fa", "YYYY/M/D")
                .format("YYYY-M-D");

              setNewProduct({
                ...NewProduct,
                dateTime: parseDate === "Invalid date" ? "" : parseDate,
              });
            }}
            label="تاریخ"
          />
        </OFFStyle>
        <PropertyLevelStyle>
          {IdFeatureValue?.map((data, index) => {
            return (
              <PropertyChooser
                handleChange={handleChangeProperty}
                handleDelete={handleDeleteProperty}
                property={data}
                handleUpdateLevel2={handleUpdateLevel2}
                optionLevel1={propertyLevel1Option}
                optionLevelTow={propertyLevel2Option}
                number={index + 1}
                key={index}
              />
            );
          })}
          <button className="add-child-btn" onClick={addProperty}>
            افزودن ویژگی
          </button>
        </PropertyLevelStyle>
      </PropertyWrapper>
      <GetCategoryLevelOne
        idDefault={null}
        show={show?.level1}
        handleClose={() => {
          setShow({ ...show, level1: false });
        }}
        levelsProperty={levelsProperty}
        setLevelsProperty={setLevelsProperty}
      />
      <GetCategoryLevelTwo
        show={show?.level2}
        handleClose={() => {
          setShow({ ...show, level2: false });
        }}
        levelsProperty={levelsProperty}
        setLevelsProperty={setLevelsProperty}
      />
      <GetCategoryLevelThree
        show={show?.level3}
        handleClose={() => {
          setShow({ ...show, level3: false });
        }}
        levelsProperty={levelsProperty}
        setLevelsProperty={setLevelsProperty}
      />
    </AddPropertyStyle>
  );
}

const AddPropertyStyle = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

const PropertyWrapper = styled.div`
  padding: 1rem 2rem;
`;

const LevelGroupChooser = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

const SelectLevel = styled.div`
  width: 100%;
  height: 2rem;
  border: 2px solid #647885;
  background-color: ${({ theme }) => theme.box} !important;
  border-radius: 1rem;
  color: ${({ theme }) => theme.text};
  cursor: pointer;
  display: flex;
  padding: 0 1rem;
  justify-content: space-between;
  align-items: center;
`;

const OccationStyle = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 2rem;
  width: 100%;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #647885;

  .contain {
    width: 100%;
  }

  .collapse {
    margin-top: 1rem;
    width: 100% !important;
    row-gap: 1rem;
  }
`;

const GroupElement = styled.div``;

export const Label = styled.label`
  font-size: 14px;
  display: block;
  margin: 6px 0;
  color: ${({ theme }) => theme.text};
`;

const OccationTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const OFFStyle = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: 2rem;
  row-gap: 1rem;
`;

const PropertyLevelStyle = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  /* margin-top: 2rem; */
  .add-child-btn {
    padding: 0.8rem 1.5rem;
    outline: none;
    margin: 0 auto;
    margin-top: 2rem;
    border: none;
    border-radius: 0.5rem;
    width: 200px;
    color: #fff;
    background: #009ef7;
  }
`;

const PropertyChooserStyle = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 2rem;

  .title {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 1rem;
  }

  .getProperty {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
  }
`;

const SupplierStyle = styled.div`
  width: 100%;
  margin-top: 1rem;
`;

export default AddProperty;
